import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import notify from '../shared/feedback/notifications';
import { Button, MenuItem } from 'react-bootstrap';
import { Translate } from '../shared/LanguageService';
import * as userActions from '../actions/userActions';

interface ImpersonateButtonProps {
    userId: number;
    router: any;
    actions: any;
    skipRedirect?: boolean;
    type?: 'MenuItem';
    afterLoginPath?: string;
}

class ImpersonateButton extends React.Component<ImpersonateButtonProps, any> {
    constructor(props: any) {
        super(props);
        this.impersonate = this.impersonate.bind(this);
    }

    impersonate(): void {
        const { history } = this.props;

        if (this.props.afterLoginPath) {
            history.push(this.props.afterLoginPath);
        } else if (this.props.skipRedirect !== true) {
            history.push('/');
        }

        this.props.actions
            .impersonate(this.props.userId)
            .then(() => {
                notify.success(Translate('impersonation/notification/now-impersonating'));
            })
            .catch((error: any) => {
                notify.failure(Translate('impersonation/notification/impersonation-failed'));
            });
    }

    render() {
        if (this.props.type === 'MenuItem') {
            return (
                <MenuItem onClick={this.impersonate}>
                    <i className="material-icons">supervisor_account</i>{' '}
                    {Translate('impersonation/button-label/impersonate')}
                </MenuItem>
            );
        }
        return (
            <Button onClick={this.impersonate} bsStyle="default">
                <i className="material-icons">supervisor_account</i>{' '}
                {Translate('impersonation/button-label/impersonate')}
            </Button>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {};
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            impersonate: (id: number) => dispatch(userActions.impersonate(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImpersonateButton));
